import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { dishesSteps } from 'common/constants/menu';
import {
  getDishCategories,
  updateOrCreateRequest,
  getByIdRequest,
  changeFormStep,
  resetListData as resetListDataAction,
  resetErrors,
  deleteDishCategory,
  changeDishCategoryPosition,
} from './actions';
import {
  dishCategoryListDataSelector,
  dishCategoryStepSelector,
  dishCategoryCompletedStepsSelector,
  createOrUpdateErrorsSelector,
  createOrUpdateInProcessSelector,
  deleteInProcessSelector,
} from './selectors';

export const useDishCategory = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const listData = useSelector(dishCategoryListDataSelector);
  const completedSteps = useSelector(dishCategoryCompletedStepsSelector);
  const step = useSelector(dishCategoryStepSelector);
  const createOrUpdateErrors = useSelector(createOrUpdateErrorsSelector);
  const createOrUpdateInProcess = useSelector(createOrUpdateInProcessSelector);
  const deleteInProcess = useSelector(deleteInProcessSelector);

  const handleGetDishCategories = () => {
    dispatch(getDishCategories({
      params: {
        per: 10000,
      }
    }));
  };

  const handleChangeDishCategoryPosition = (id, position, originalPosition) => {
    dispatch(changeDishCategoryPosition({ id, position, originalPosition }));
  };
  const handleDeleteDishCategory = (id) => {
    dispatch(deleteDishCategory({ id, history }));
  };

  const handleGetByIdCategory = (id) => {
    dispatch(getByIdRequest({ id }));
  };

  const handleResetErrors = () => {
    if (createOrUpdateErrors) {
      dispatch(resetErrors());
    }
  };

  const resetListData = () => {
    dispatch(resetListDataAction());
  };

  const handleChangeDishStep = (nextStep) => {
    dispatch(
      changeFormStep({
        step: nextStep,
        completedSteps: [...completedSteps, nextStep],
      }),
    );
  };

  const handleResetSteps = () => {
    dispatch(
      changeFormStep({
        step: dishesSteps.first,
        completedSteps: [dishesSteps.first],
      }),
    );
  };

  const handleUpdateOrCreate = (data, id) => {
    dispatch(updateOrCreateRequest({ formData: data, history, id }));
  };

  return {
    handleResetErrors,
    handleGetDishCategories,
    handleUpdateOrCreate,
    listData,
    handleGetByIdCategory,

    step,
    completedSteps,
    handleResetSteps,
    handleChangeDishStep,
    resetListData,
    createOrUpdateErrors,
    createOrUpdateInProcess,
    deleteInProcess,
    handleDeleteDishCategory,
    handleChangeDishCategoryPosition,
  };
};
